import type { DropdownSelectOption } from '@acme/foundation';

interface CertificateData {
  name: string;
  thumbprint: string;
  validTo: string;
}

export const formatCertificateDate = (dateString: string): string => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear()).slice(-2);

  return `${day}.${month}.${year}`;
};

export const mapCertificatesToOptions = (
  certificates: CertificateData[]
): DropdownSelectOption[] => {
  return certificates.map(({ name, thumbprint, validTo }) => {
    const formattedDate = formatCertificateDate(validTo);

    return {
      value: thumbprint,
      label: (
        <div>
          <span className="font-medium">{name} </span>
          <span className="text-xs text-gray-500">КЭП до {formattedDate}</span>
        </div>
      ),
    };
  });
};
